import {HttpErrorResponse, HttpInterceptorFn} from '@angular/common/http';
import {HttpMethod} from "../enums/http-method.enum";
import {catchError} from "rxjs/operators";
import {throwError} from "rxjs";
import {SnackbarService} from "../services/snackbar.service";
import {inject} from "@angular/core";
import {ConfigurationService} from "../services/configuration.service";

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const snackBarService = inject(SnackbarService)
  const configuration = inject(ConfigurationService).configuration
  const isModifyingRequest = [HttpMethod.POST, HttpMethod.PUT, HttpMethod.DELETE].includes(req.method as HttpMethod);

  const prepareErrorMessage = (error: HttpErrorResponse): string => {
    if(error.status === 0) {
      return 'Cannot reach the server.'
    }
    return `${error.statusText}, Status Code: ${error.status}`
  }

  if(isModifyingRequest && req.url.includes(configuration.api.backendUrl)) {
    return next(req).pipe(
      catchError((error: HttpErrorResponse) => {
        snackBarService.Error(prepareErrorMessage(error))
        return throwError(() => error);
      })
    )
  }

  return next(req);
};
